import { datadogRum } from '@datadog/browser-rum';

/**
 * Expose Datadog RUM in the global scope, so that our Haml templates can initialise it with server-side environment information.
 *
 * Note: We don't use webpack's expose-loader to do this, because it is
 * [incompatible with DllPlugin][expose-loader-25].
 *
 * [expose-loader-25]: https://github.com/webpack-contrib/expose-loader/issues/25
 */
window.datadogRum = datadogRum;
